const lazyRegistration = cb => {
    import(/* webpackChunkName: "hf-registration-form" */ "./registration").then(
        ({ default: init }) => cb(init)
    );
};

export default () => {
    const registration = document.getElementById('hf-registration-form');

    if (registration) {
        window.dataLayer = window.dataLayer || [];
        const data = JSON.parse(registration.getAttribute('data-form'))
        const formURL = registration.getAttribute('data-form-url');
        const qualificationChecks = JSON.parse(registration.getAttribute('data-qualification'));
        lazyRegistration(initForm => initForm(registration, {...data, formURL, qualificationChecks}));
    }
};